import Icon from './Icon';
import './Button.css';

/**
 * Button component with variants
 * @param {string} variant - "primary", "secondary", "danger", "ghost"
 * @param {string} size - "xs", "sm", "md", "lg"
 * @param {string} icon - Icon name to display
 * @param {boolean} iconOnly - If true, shows only icon
 */
const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  icon,
  iconOnly = false,
  className = '',
  ...props
}) => {
  return (
    <button
      className={`btn btn-${variant} btn-${size} ${iconOnly ? 'btn-icon-only' : ''} ${className}`}
      {...props}
    >
      {icon && <Icon name={icon} size={size === 'xs' ? 'xs' : 'sm'} />}
      {!iconOnly && children}
    </button>
  );
};

export default Button;
